var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "icon-search_svg__cls-1",
  d: "M17.2 15.74l4.52 4.53a1 1 0 11-1.41 1.41l-4.52-4.52a8.55 8.55 0 111.41-1.42zm-2-.72a6.49 6.49 0 10-.12.12l.06-.06z"
})));

export default SvgIconSearch;